import { NavLink } from "react-router-dom";
import Container from "../../../shared/design/Container";
import Eyebrow from "../../../shared/design/Eyebrow";
import Rockies from "../../../assets/bg-rockys.png";
import Desert from "../../../assets/home-cta-2.jpg";
import Coast from "../../../assets/home-aboutus-1.jpg";
import Tropics from "../../../assets/bg-ropeswing.png";
import Dunes from "../../../assets/home-cta-1.jpg";

type Tile = {
  label: string;
  meta?: string;
  img: string;
  className: string;
  titleClass: string;
};

const tiles: Tile[] = [
  {
    label: "The Rockies",
    meta: "14 tours",
    img: Rockies,
    className: "sm:col-span-2 sm:row-span-2",
    titleClass: "text-[28px]",
  },
  { label: "Desert SW", img: Desert, className: "", titleClass: "text-[20px]" },
  { label: "Pacific Coast", img: Coast, className: "", titleClass: "text-[20px]" },
  { label: "Tropics", img: Tropics, className: "", titleClass: "text-[20px]" },
  { label: "The Dunes", img: Dunes, className: "", titleClass: "text-[20px]" },
];

const Destinations = () => {
  return (
    <Container className="py-8">
      <div className="mb-[30px]">
        <Eyebrow className="mb-2.5">03 — WHERE WE WANDER</Eyebrow>
        <h2 className="font-serif text-[32px] font-normal tracking-[-0.02em] md:text-[42px]">
          From coast to wild coast
        </h2>
      </div>
      <div className="grid auto-rows-[200px] grid-cols-2 gap-4 md:grid-cols-4">
        {tiles.map((t) => (
          <NavLink
            key={t.label}
            to="/tours"
            className={`group relative overflow-hidden rounded-[18px] ${t.className}`}
          >
            <img
              src={t.img}
              alt={t.label}
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.08]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[rgba(19,58,69,0.7)] to-transparent to-[55%]" />
            <div className="absolute bottom-4 left-[18px] text-white">
              <div className={`font-serif ${t.titleClass}`}>{t.label}</div>
              {t.meta && (
                <div className="font-mono text-[13px] text-[#cfe0dc]">
                  {t.meta}
                </div>
              )}
            </div>
          </NavLink>
        ))}
      </div>
    </Container>
  );
};

export default Destinations;
